import { useEffect, useState } from "react";
import api from "../utils/api";

/**
 * 🔒 Frontend CBT subscription checker
 * - TRUE  → Active PAID CBT subscription
 * - FALSE → Trial / expired / no CBT
 */
export default function useCBTSubscription() {
  const [loading, setLoading] = useState(true);
  const [hasCBT, setHasCBT] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    let mounted = true;

    const check = async () => {
      try {
        /**
         * IMPORTANT:
         * This endpoint MUST be protected by requireCBTSubscription on backend
         * If user is trial → backend returns 403
         */
        await api.get("/jamb/my-registration");

        if (mounted) {
          setHasCBT(true);   // reached here → paid CBT user
          setError(null);
        }
      } catch (err) {
        if (mounted) {
          setHasCBT(false);  // blocked → trial or no subscription
          setError(err?.response?.data || null);
        }
      } finally {
        if (mounted) setLoading(false);
      }
    };

    check();

    return () => {
      mounted = false;
    };
  }, []);

  return {
    loading,
    hasCBT,
    error,
  };
}
